var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinessHoursIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.5,
    height: 31.5,
    viewBox: "0 0 31.5 31.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Open_times",
    "data-name": "Open times",
    d: "M17,3.448A13.552,13.552,0,1,0,30.552,17,13.552,13.552,0,0,0,17,3.448ZM1.25,17A15.75,15.75,0,1,1,17,32.75,15.75,15.75,0,0,1,1.25,17ZM17,10.041a1.1,1.1,0,0,1,1.1,1.1v5.405l3.341,3.341a1.1,1.1,0,0,1-1.554,1.554l-3.663-3.663A1.1,1.1,0,0,1,15.9,17V11.14A1.1,1.1,0,0,1,17,10.041Z",
    transform: "translate(-1.25 -1.25)",
    fill: "#2a6bec",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessHoursIcon);
export default __webpack_public_path__ + "static/media/business-hours-icon.e4758ff336f9bd708b0c40f09f842856.svg";
export { ForwardRef as ReactComponent };